import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';
import CustomModal from './CustomModal';

function BizLicensePreview(props) {
  var [src, setSrc] = useState(null);
  var [err, setErr] = useState(false);
  useEffect(function() {
    authFetch(API + '/auth/biz-license/' + props.companyId).then(function(r) {
      if (r.ok) return r.blob(); throw new Error('no file');
    }).then(function(blob) { setSrc(URL.createObjectURL(blob)); }).catch(function() { setErr(true); });
  }, [props.companyId]);
  if (err || !src) return null;
  return <div style={{marginTop:8}}><img src={src} alt="사업자등록증" style={{maxWidth:'100%',maxHeight:160,borderRadius:6,border:'1px solid #e5e7eb'}} /></div>;
}

function AdminCompany(props) {
  var [modal, setModal] = useState(null);
  var closeModal = function() { setModal(null); };
  // 안전망: 백엔드가 403/오류 객체를 반환해 props.companies가 배열이 아닐 때 .filter 크래시 방지
  var companies = Array.isArray(props.companies) ? props.companies : [];
  var companyUsers = props.companyUsers;
  var expandedCompany = props.expandedCompany;
  var companyFilter = props.companyFilter;
  var setCompanyFilter = props.setCompanyFilter;
  var handleExpandCompany = props.handleExpandCompany;
  var openAddCompany = props.openAddCompany;
  var openEditCompany = props.openEditCompany;
  var toggleCompanyStatus = props.toggleCompanyStatus;
  var openAddUser = props.openAddUser;
  var openEditUser = props.openEditUser;
  var resetPassword = props.resetPassword;
  var toggleUserActive = props.toggleUserActive;
  var showCompanyModal = props.showCompanyModal;
  var setShowCompanyModal = props.setShowCompanyModal;
  var editCompany = props.editCompany;
  var companyForm = props.companyForm;
  var setCompanyForm = props.setCompanyForm;
  var saveCompany = props.saveCompany;
  var ocrPreview = props.ocrPreview;
  var ocrLoading = props.ocrLoading;
  var handleBizLicenseUpload = props.handleBizLicenseUpload;
  var ocrResultPopup = props.ocrResultPopup;
  var setOcrResultPopup = props.setOcrResultPopup;
  var ocrEdit = props.ocrEdit;
  var setOcrEdit = props.setOcrEdit;
  var showToast = props.showToast;
  var showUserModal = props.showUserModal;
  var setShowUserModal = props.setShowUserModal;
  var userForm = props.userForm;
  var setUserForm = props.setUserForm;
  var saveUser = props.saveUser;
  var showEditUserModal = props.showEditUserModal;
  var setShowEditUserModal = props.setShowEditUserModal;
  var editUser = props.editUser;
  var editUserForm = props.editUserForm;
  var setEditUserForm = props.setEditUserForm;
  var saveEditUser = props.saveEditUser;
  var showNoticeModal = props.showNoticeModal;
  var setShowNoticeModal = props.setShowNoticeModal;
  var noticeList = props.noticeList;
  var noticeForm = props.noticeForm;
  var setNoticeForm = props.setNoticeForm;
  var editNotice = props.editNotice;
  var setEditNotice = props.setEditNotice;
  var saveNotice = props.saveNotice;
  var fetchNotices = props.fetchNotices;

  var th = props.th;
  var td = props.td;
  var badge = props.badge;
  var btnStyle = props.btnStyle;
  var inputStyle = props.inputStyle;
  var modalOverlay = props.modalOverlay;
  var modalBox = props.modalBox;

  var pendingCompanies = companies.filter(function(c) { return c.approval_status === 'pending'; });
  var [rejectReason, setRejectReason] = useState('');
  var [rejectTarget, setRejectTarget] = useState(null);
  var fetchCompanies = props.fetchCompanies;

  var handleApprove = function(companyId) {
    setModal({ type: 'info', title: '가입 승인', message: '이 업체의 가입을 승인하시겠습니까?\n체험판 90일이 시작됩니다.', confirmText: '승인', onConfirm: function() {
      closeModal();
      authFetch(API + '/admin/companies/' + companyId + '/approve', { method: 'POST' }).then(function(r) { return r.json(); }).then(function(d) {
        if (d.success && fetchCompanies) fetchCompanies();
      });
    }});
  };

  var handleReject = function(companyId) {
    setRejectTarget(companyId);
    setRejectReason('');
  };

  var submitReject = function() {
    authFetch(API + '/admin/companies/' + rejectTarget + '/reject', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reason: rejectReason })
    }).then(function(r) { return r.json(); }).then(function(d) {
      if (d.success) { setRejectTarget(null); if (fetchCompanies) fetchCompanies(); }
    });
  };

  return (<div>
    {/* 승인 대기 업체 */}
    {pendingCompanies.length > 0 && (<div style={{background:'#fef3c7',border:'1px solid #f59e0b',borderRadius:12,padding:16,marginBottom:16}}>
      <h4 style={{margin:'0 0 10px',fontSize:14,fontWeight:700,color:'#92400e'}}>승인 대기 ({pendingCompanies.length}건)</h4>
      {pendingCompanies.map(function(c) { return (
        <div key={c.id} style={{background:'#fff',borderRadius:8,padding:'10px 14px',marginBottom:6,border:'1px solid #fde68a'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <span style={{fontWeight:700,fontSize:13}}>{c.name}</span>
              {c.name_en ? <span style={{fontSize:11,color:'#888',marginLeft:6}}>{c.name_en}</span> : null}
              <div style={{fontSize:11,color:'#64748b',marginTop:2}}>{c.ceo ? c.ceo + ' · ' : ''}{c.tel || ''}{c.bizNo ? ' · ' + c.bizNo : ''}</div>
            </div>
            <div style={{display:'flex',gap:6}}>
              <button onClick={function(){handleApprove(c.id)}} style={{padding:'6px 14px',background:'#16a34a',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>승인</button>
              <button onClick={function(){handleReject(c.id)}} style={{padding:'6px 14px',background:'#fff',color:'#dc2626',border:'1px solid #fca5a5',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>거절</button>
            </div>
          </div>
          <BizLicensePreview companyId={c.id} />
        </div>
      ); })}
    </div>)}

    {/* 거절 사유 입력 */}
    {rejectTarget && (<div style={modalOverlay}><div style={modalBox}>
      <h3 style={{margin:'0 0 12px',fontSize:16}}>거절 사유</h3>
      <textarea value={rejectReason} onChange={function(e){setRejectReason(e.target.value)}} placeholder="거절 사유를 입력해주세요 (선택)" style={{width:'100%',minHeight:80,padding:10,border:'1px solid #d0d5dd',borderRadius:8,fontSize:13,boxSizing:'border-box',resize:'vertical'}}></textarea>
      <div style={{display:'flex',gap:8,marginTop:12,justifyContent:'flex-end'}}>
        <button onClick={function(){setRejectTarget(null)}} style={{padding:'8px 16px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:13,cursor:'pointer',background:'#fff'}}>취소</button>
        <button onClick={submitReject} style={{padding:'8px 16px',background:'#dc2626',color:'#fff',border:'none',borderRadius:6,fontSize:13,fontWeight:600,cursor:'pointer'}}>거절 확정</button>
      </div>
    </div></div>)}

    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
      <div style={{display:'flex',alignItems:'center',gap:12}}>
        <h3 style={{margin:0,fontSize:16,fontWeight:700,color:'#0f172a'}}>업체/계정 관리</h3>
        <div style={{display:'flex',gap:4}}>
          {[{k:'all',l:'전체'},{k:'일반업체',l:'일반업체'},{k:'대행업체',l:'대행업체'}].map(function(f){return(
            <button key={f.k} onClick={function(){setCompanyFilter(f.k)}} style={{padding:'4px 12px',borderRadius:6,fontSize:11,fontWeight:companyFilter===f.k?700:500,border:'1px solid '+(companyFilter===f.k?'#3b82f6':'#e5e7eb'),background:companyFilter===f.k?'#eff6ff':'#fff',color:companyFilter===f.k?'#2563eb':'#64748b',cursor:'pointer'}}>{f.l}</button>
          )})}
        </div>
      </div>
      <div style={{display:'flex',gap:8}}>
        <button onClick={function(){setShowNoticeModal(true);fetchNotices()}} style={{padding:'8px 16px',background:'#f59e0b',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>📢 공지사항 관리</button>
        <button onClick={openAddCompany} style={btnStyle}>+ 업체 추가</button>
      </div>
    </div>
    <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,overflow:'hidden'}}>
      <table style={{width:'100%',borderCollapse:'collapse'}}>
        <thead><tr>
          {['업체명','유형','대표자','사업자번호','계정수','요금제','상태','가입일','작업'].map(function(h){return <th key={h} style={th}>{h}</th>})}
        </tr></thead>
        <tbody>
          {companies.filter(function(c){return companyFilter==='all'||(c.companyType||'일반업체')===companyFilter}).length===0&&<tr><td colSpan={9} style={{...td,textAlign:'center',color:'#94a3b8',padding:40}}>등록된 업체가 없습니다</td></tr>}
          {companies.filter(function(c){return companyFilter==='all'||(c.companyType||'일반업체')===companyFilter}).map(function(c){return(<React.Fragment key={c.id}>
            <tr style={{cursor:'pointer',background:expandedCompany===c.id?'#f0f9ff':'#fff'}} onClick={function(){handleExpandCompany(c.id)}}>
              <td style={{...td,fontWeight:700}}><span style={{marginRight:6}}>{expandedCompany===c.id?'▼':'▶'}</span>{c.name}</td>
              <td style={td}><span style={{padding:'2px 8px',borderRadius:10,fontSize:10,fontWeight:600,background:(c.companyType||'일반업체')==='대행업체'?'#fff7ed':'#eff6ff',color:(c.companyType||'일반업체')==='대행업체'?'#ea580c':'#2563eb'}}>{c.companyType||'일반업체'}</span></td>
              <td style={td}>{c.ceo}</td>
              <td style={td}>{c.bizNo}</td>
              <td style={{...td,textAlign:'center'}}>{c.userCount||0}</td>
              <td style={td}>{(function(){
                var p=c.plan||'trial';
                var planColors={trial:'#92400e',basic:'#64748b',pro:'#166534'};
                var labels={trial:'Trial',basic:'Basic',pro:'Pro'};
                var planLimitsClient={trial:100,basic:300,pro:999999};
                var planChange=function(newPlan){
                  if(newPlan===p)return;
                  var isDown=planLimitsClient[newPlan]<planLimitsClient[p];
                  var trialExpired=c.trial_end&&c.trial_end<new Date().toISOString().slice(0,10);
                  var msg=c.name+' 요금제를 '+labels[p]+' → '+labels[newPlan]+'로 변경합니다.\n\n'+
                    (isDown?'⚠️ 다운그레이드: 다음 달 1일부터 적용됩니다.':'✓ 업그레이드: 즉시 적용됩니다.')+
                    (isDown&&p==='pro'&&trialExpired?'\n\n🚨 이 업체의 체험판(trial_end)이 이미 만료된 상태입니다. 다운그레이드 적용 시 즉시 OCR이 차단될 수 있습니다 (admin이 별도로 trial_end를 갱신해 주세요).':'');
                  setModal({type:'confirm',title:'요금제 변경',message:msg,confirmText:'변경',onConfirm:function(){
                    closeModal();
                    authFetch(API+'/admin/companies/'+c.id+'/set-plan',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({plan:newPlan})})
                      .then(function(r){return r.json()})
                      .then(function(d){
                        if(d.success){
                          if(d.effective==='scheduled')showToast&&showToast('다음 달 1일('+d.effective_at+')부터 '+labels[newPlan]+'로 변경 예약됨','success');
                          else showToast&&showToast('요금제가 '+labels[newPlan]+'로 즉시 변경됨','success');
                          if(fetchCompanies)fetchCompanies();
                        }else{
                          showToast&&showToast(d.error||'변경 실패','error');
                        }
                      }).catch(function(){showToast&&showToast('네트워크 오류','error')});
                  }});
                };
                return <div onClick={function(e){e.stopPropagation()}} style={{display:'flex',flexDirection:'column',gap:2,alignItems:'flex-start'}}>
                  <select value={p} onChange={function(e){planChange(e.target.value)}} style={{padding:'2px 6px',borderRadius:6,fontSize:11,fontWeight:600,color:planColors[p]||planColors.trial,background:'#fff',border:'1px solid #e5e7eb',cursor:'pointer'}}>
                    <option value="trial">Trial</option>
                    <option value="basic">Basic</option>
                    <option value="pro">Pro</option>
                  </select>
                  {c.pending_plan&&c.pending_plan_effective_at?<span style={{fontSize:9,color:'#dc2626',fontWeight:600}}>pending: {labels[c.pending_plan]||c.pending_plan} @ {c.pending_plan_effective_at}</span>:null}
                </div>;
              })()}</td>
              <td style={td}>{badge(c.status,c.status)}</td>
              <td style={td}>{c.createdAt}</td>
              <td style={td}>
                <button onClick={function(e){openEditCompany(e,c)}} style={{padding:'4px 10px',border:'1px solid #d0d5dd',borderRadius:4,fontSize:11,cursor:'pointer',background:'#fff',marginRight:4}}>수정</button>
                <button onClick={function(e){toggleCompanyStatus(e,c)}} style={{padding:'4px 10px',border:'1px solid #fca5a5',borderRadius:4,fontSize:11,cursor:'pointer',background:'#fff',color:c.status==='활성'?'#dc2626':'#166534'}}>{c.status==='활성'?'비활성':'활성화'}</button>
              </td>
            </tr>
            {expandedCompany===c.id&&<tr><td colSpan={9} style={{padding:0,background:'#f8fafc'}}>
              <div style={{padding:'12px 20px'}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                  <span style={{fontSize:12,fontWeight:700,color:'#475569'}}>소속 사용자</span>
                  <button onClick={function(){openAddUser(c.id)}} style={{padding:'4px 12px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:4,fontSize:11,fontWeight:600,cursor:'pointer'}}>+ 사용자 추가</button>
                </div>
                <table style={{width:'100%',borderCollapse:'collapse',background:'#fff',borderRadius:8,overflow:'hidden'}}>
                  <thead><tr>
                    {['아이디','이름','역할','상태','가입일','작업'].map(function(h){return <th key={h} style={{...th,fontSize:11,padding:'6px 10px'}}>{h}</th>})}
                  </tr></thead>
                  <tbody>
                    {(!companyUsers[c.id]||companyUsers[c.id].length===0)&&<tr><td colSpan={6} style={{...td,textAlign:'center',color:'#94a3b8',fontSize:12}}>소속 사용자 없음</td></tr>}
                    {(companyUsers[c.id]||[]).map(function(u){return(
                      <tr key={u.id}>
                        <td style={{...td,fontSize:12,color:'#64748b'}}>{u.userId}</td>
                        <td style={{...td,fontSize:12}}>{u.name}</td>
                        <td style={{...td,fontSize:12}}>{badge(u.role==='관리자'?'active':'none',u.role)}</td>
                        <td style={{...td,fontSize:12}}>{u.active?badge('활성','활성'):badge('비활성','비활성')}</td>
                        <td style={{...td,fontSize:11,color:'#94a3b8'}}>{u.createdAt}</td>
                        <td style={{...td,fontSize:12}}>
                          <button onClick={function(){openEditUser(u)}} style={{padding:'3px 8px',border:'1px solid #d0d5dd',borderRadius:4,fontSize:10,cursor:'pointer',background:'#fff',marginRight:3}}>수정</button>
                          <button onClick={function(){resetPassword(u)}} style={{padding:'3px 8px',border:'1px solid #d0d5dd',borderRadius:4,fontSize:10,cursor:'pointer',background:'#fff',marginRight:3}}>PW초기화</button>
                          <button onClick={function(){toggleUserActive(u)}} style={{padding:'3px 8px',border:'1px solid '+(u.active?'#fca5a5':'#86efac'),borderRadius:4,fontSize:10,cursor:'pointer',background:'#fff',color:u.active?'#dc2626':'#166534'}}>{u.active?'비활성화':'활성화'}</button>
                        </td>
                      </tr>
                    )})}
                  </tbody>
                </table>
              </div>
            </td></tr>}
          </React.Fragment>)})}
        </tbody>
      </table>
    </div>

    {/* 업체 추가/수정 모달 */}
    {showCompanyModal&&<div style={modalOverlay} onClick={function(){setShowCompanyModal(false)}}>
      <div style={{...modalBox,width:ocrPreview?720:460}} onClick={function(e){e.stopPropagation()}}>
        <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:700,color:'#0f172a'}}>{editCompany?'업체 수정':'업체 추가'}</h3>
        {!editCompany&&<div style={{marginBottom:16}}>
          <div
            onDragOver={function(e){e.preventDefault();e.currentTarget.style.borderColor='#1B3A5C'}}
            onDragLeave={function(e){e.currentTarget.style.borderColor='#d0d5dd'}}
            onDrop={function(e){e.preventDefault();e.currentTarget.style.borderColor='#d0d5dd';if(e.dataTransfer.files[0])handleBizLicenseUpload(e.dataTransfer.files[0])}}
            onClick={function(){document.getElementById('biz-license-input').click()}}
            style={{border:'2px dashed #d0d5dd',borderRadius:8,padding:ocrPreview?0:24,textAlign:'center',cursor:'pointer',background:'#f8fafc',position:'relative',overflow:'hidden'}}
          >
            {ocrLoading&&<div style={{position:'absolute',top:0,left:0,right:0,bottom:0,background:'rgba(255,255,255,0.9)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',zIndex:2}}>
              <div style={{width:32,height:32,border:'3px solid #e5e7eb',borderTopColor:'#1B3A5C',borderRadius:'50%',animation:'spin 1s linear infinite'}}></div>
              <div style={{marginTop:8,fontSize:12,color:'#1B3A5C',fontWeight:600}}>사업자등록증 분석 중...</div>
              <style>{'{@keyframes spin{to{transform:rotate(360deg)}}}'}</style>
            </div>}
            {ocrPreview?<img src={ocrPreview} alt="사업자등록증" style={{maxWidth:'100%',maxHeight:200,display:'block',margin:'0 auto'}}/>:
            <div>
              <div style={{fontSize:28,marginBottom:8,color:'#94a3b8'}}>&#128196;</div>
              <div style={{fontSize:13,color:'#64748b',fontWeight:600}}>사업자등록증 업로드</div>
              <div style={{fontSize:11,color:'#94a3b8',marginTop:4}}>클릭 또는 드래그하여 이미지를 업로드하면 자동으로 정보를 인식합니다</div>
            </div>}
          </div>
          <input id="biz-license-input" type="file" accept="image/*" style={{display:'none'}} onChange={function(e){if(e.target.files[0])handleBizLicenseUpload(e.target.files[0])}}/>
        </div>}
        {[{k:'name',l:'업체명 *'},{k:'ceo',l:'대표자'},{k:'bizNo',l:'사업자번호'},{k:'address',l:'주소'},{k:'tel',l:'전화번호'},{k:'email',l:'이메일'},{k:'bizType',l:'업태'},{k:'bizItem',l:'종목'},{k:'openDate',l:'개업일'}].map(function(f){return(
          <div key={f.k} style={{marginBottom:12}}>
            <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>{f.l}</label>
            <input value={companyForm[f.k]} onChange={function(e){setCompanyForm(function(p){var n=Object.assign({},p);n[f.k]=e.target.value;return n})}} style={inputStyle} onKeyDown={function(e){if(e.key==='Enter')saveCompany()}}/>
          </div>
        )})}
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>업체 유형</label>
          <select value={companyForm.companyType||'일반업체'} onChange={function(e){setCompanyForm(function(p){return Object.assign({},p,{companyType:e.target.value})})}} style={inputStyle}>
            <option value="일반업체">일반업체</option>
            <option value="대행업체">대행업체</option>
          </select>
        </div>
        <div style={{display:'flex',gap:8,marginTop:16}}>
          <button onClick={saveCompany} style={{...btnStyle,flex:1}}>{editCompany?'수정':'등록'}</button>
          <button onClick={function(){setShowCompanyModal(false)}} style={{flex:1,padding:'8px 16px',background:'#fff',color:'#374151',border:'1px solid #d0d5dd',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>취소</button>
        </div>
      </div>
    </div>}

    {/* OCR 비교 팝업 */}
    {ocrResultPopup&&ocrPreview&&<div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:10000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={function(){setOcrResultPopup(false)}}>
      <div style={{background:'#fff',borderRadius:12,boxShadow:'0 16px 48px rgba(0,0,0,0.25)',padding:20,display:'flex',gap:16,maxWidth:'90vw',maxHeight:'85vh',overflow:'auto',position:'relative'}} onClick={function(e){e.stopPropagation()}}>
        <button onClick={function(){setOcrResultPopup(false)}} style={{position:'absolute',top:10,right:10,background:'#f1f5f9',border:'none',borderRadius:'50%',width:28,height:28,fontSize:16,cursor:'pointer',color:'#64748b',lineHeight:1,zIndex:1}}>&#10005;</button>
        <div style={{flexShrink:0,maxWidth:400}}>
          <div style={{fontSize:13,fontWeight:700,color:'#0f172a',marginBottom:8}}>원본 이미지</div>
          <img src={ocrPreview} alt="사업자등록증" style={{maxWidth:380,maxHeight:'70vh',borderRadius:8,objectFit:'contain',border:'1px solid #e5e7eb'}}/>
        </div>
        <div style={{width:280,flexShrink:0}}>
          <div style={{fontSize:14,fontWeight:700,color:'#0f172a',marginBottom:12}}>OCR 인식 결과 (수정 가능)</div>
          {[{k:'name',l:'상호(업체명)'},{k:'ceo',l:'대표자'},{k:'bizNo',l:'사업자번호'},{k:'address',l:'주소'},{k:'tel',l:'전화번호'},{k:'bizType',l:'업태'},{k:'bizItem',l:'종목'},{k:'openDate',l:'개업일'}].map(function(f){return(
            <div key={f.k} style={{marginBottom:8}}>
              <div style={{fontSize:11,color:'#64748b',marginBottom:2}}>{f.l}</div>
              <input value={ocrEdit[f.k]||''} onChange={function(e){setOcrEdit(function(p){var n=Object.assign({},p);n[f.k]=e.target.value;return n})}} style={{width:'100%',padding:'5px 8px',border:'1px solid #d0d5dd',borderRadius:4,fontSize:13,boxSizing:'border-box',background:ocrEdit[f.k]?'#f0fdf4':'#fff'}}/>
            </div>
          )})}
          <button onClick={function(){
            setCompanyForm(function(p){return Object.assign({},p,{name:ocrEdit.name||p.name,ceo:ocrEdit.ceo||p.ceo,bizNo:ocrEdit.bizNo||p.bizNo,address:ocrEdit.address||p.address,tel:ocrEdit.tel||p.tel,bizType:ocrEdit.bizType||p.bizType,bizItem:ocrEdit.bizItem||p.bizItem,openDate:ocrEdit.openDate||p.openDate})});
            setOcrResultPopup(false);
            showToast&&showToast('OCR 결과가 폼에 반영되었습니다','success');
          }} style={{width:'100%',marginTop:12,padding:'10px',background:'#1B3A5C',color:'#fff',border:'none',borderRadius:6,fontSize:13,fontWeight:700,cursor:'pointer'}}>적용</button>
          <button onClick={function(){setOcrResultPopup(false)}} style={{width:'100%',marginTop:6,padding:'8px',background:'#fff',color:'#64748b',border:'1px solid #d0d5dd',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>취소</button>
        </div>
      </div>
    </div>}

    {/* 사용자 추가 모달 */}
    {showUserModal&&<div style={modalOverlay} onClick={function(){setShowUserModal(false)}}>
      <div style={modalBox} onClick={function(e){e.stopPropagation()}}>
        <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:700,color:'#0f172a'}}>사용자 추가</h3>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>아이디 *</label>
          <input value={userForm.userId} onChange={function(e){setUserForm(function(p){return Object.assign({},p,{userId:e.target.value})})}} style={inputStyle}/>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>비밀번호</label>
          <input value={userForm.password} onChange={function(e){setUserForm(function(p){return Object.assign({},p,{password:e.target.value})})}} style={inputStyle} placeholder="기본: 1234"/>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>이름 *</label>
          <input value={userForm.name} onChange={function(e){setUserForm(function(p){return Object.assign({},p,{name:e.target.value})})}} style={inputStyle}/>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>역할</label>
          <select value={userForm.role} onChange={function(e){setUserForm(function(p){return Object.assign({},p,{role:e.target.value})})}} style={inputStyle}>
            <option value="관리자">관리자</option><option value="직원">직원</option><option value="말소대행">말소대행</option>
          </select>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>전화번호</label>
          <input value={userForm.phone} onChange={function(e){setUserForm(function(p){return Object.assign({},p,{phone:e.target.value})})}} style={inputStyle}/>
        </div>
        <div style={{display:'flex',gap:8,marginTop:16}}>
          <button onClick={saveUser} style={{...btnStyle,flex:1}}>추가</button>
          <button onClick={function(){setShowUserModal(false)}} style={{flex:1,padding:'8px 16px',background:'#fff',color:'#374151',border:'1px solid #d0d5dd',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>취소</button>
        </div>
      </div>
    </div>}

    {/* 사용자 수정 모달 */}
    {showEditUserModal&&<div style={modalOverlay} onClick={function(){setShowEditUserModal(false)}}>
      <div style={modalBox} onClick={function(e){e.stopPropagation()}}>
        <h3 style={{margin:'0 0 16px',fontSize:16,fontWeight:700,color:'#0f172a'}}>사용자 수정 ({editUser&&editUser.userId})</h3>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>이름</label>
          <input value={editUserForm.name} onChange={function(e){setEditUserForm(function(p){return Object.assign({},p,{name:e.target.value})})}} style={inputStyle}/>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>역할</label>
          <select value={editUserForm.role} onChange={function(e){setEditUserForm(function(p){return Object.assign({},p,{role:e.target.value})})}} style={inputStyle}>
            <option value="관리자">관리자</option><option value="직원">직원</option><option value="말소대행">말소대행</option>
          </select>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:12,fontWeight:600,color:'#374151',display:'block',marginBottom:4}}>전화번호</label>
          <input value={editUserForm.phone} onChange={function(e){setEditUserForm(function(p){return Object.assign({},p,{phone:e.target.value})})}} style={inputStyle}/>
        </div>
        <div style={{display:'flex',gap:8,marginTop:16}}>
          <button onClick={saveEditUser} style={{...btnStyle,flex:1}}>수정</button>
          <button onClick={function(){setShowEditUserModal(false)}} style={{flex:1,padding:'8px 16px',background:'#fff',color:'#374151',border:'1px solid #d0d5dd',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>취소</button>
        </div>
      </div>
    </div>}

    {/* 공지사항 관리 모달 */}
    {showNoticeModal&&<div style={modalOverlay} onClick={function(){setShowNoticeModal(false)}}>
      <div style={{...modalBox,width:560}} onClick={function(e){e.stopPropagation()}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
          <h3 style={{margin:0,fontSize:16,fontWeight:700,color:'#0f172a'}}>📢 공지사항 관리</h3>
          <button onClick={function(){setShowNoticeModal(false)}} style={{background:'none',border:'none',fontSize:18,cursor:'pointer',color:'#94a3b8'}}>✕</button>
        </div>
        <div style={{marginBottom:16,padding:14,background:'#f8fafc',borderRadius:8,border:'1px solid #e5e7eb'}}>
          <div style={{display:'flex',gap:8,marginBottom:8}}>
            <input value={noticeForm.title} onChange={function(e){setNoticeForm(Object.assign({},noticeForm,{title:e.target.value}))}} placeholder="공지 제목" style={{...inputStyle,flex:1}}/>
            <select value={noticeForm.priority} onChange={function(e){setNoticeForm(Object.assign({},noticeForm,{priority:e.target.value}))}} style={{padding:'8px 12px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:13}}>
              <option value="info">🔵 정보</option><option value="warning">🟡 주의</option><option value="urgent">🔴 긴급</option>
            </select>
          </div>
          <input value={noticeForm.content} onChange={function(e){setNoticeForm(Object.assign({},noticeForm,{content:e.target.value}))}} placeholder="공지 내용 (선택)" style={{...inputStyle,marginBottom:8}}/>
          <div style={{display:'flex',gap:8}}>
            <button onClick={saveNotice} style={{...btnStyle,flex:1}}>{editNotice?'수정':'등록'}</button>
            {editNotice&&<button onClick={function(){setEditNotice(null);setNoticeForm({title:'',content:'',priority:'info'})}} style={{padding:'8px 16px',background:'#fff',color:'#374151',border:'1px solid #d0d5dd',borderRadius:6,fontSize:12,fontWeight:600,cursor:'pointer'}}>취소</button>}
          </div>
        </div>
        <div style={{maxHeight:300,overflowY:'auto'}}>
          {noticeList.length===0&&<div style={{textAlign:'center',padding:20,color:'#94a3b8',fontSize:13}}>등록된 공지가 없습니다</div>}
          {noticeList.map(function(n){
            var ps={info:{bg:'#eff6ff',c:'#2563eb',l:'정보'},warning:{bg:'#fffbeb',c:'#92400e',l:'주의'},urgent:{bg:'#fef2f2',c:'#dc2626',l:'긴급'}};
            var s=ps[n.priority]||ps.info;
            return(<div key={n.id} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 12px',borderRadius:8,marginBottom:6,background:n.active?'#fff':'#f8fafc',border:'1px solid #e5e7eb',opacity:n.active?1:0.5}}>
              <span style={{fontSize:10,fontWeight:700,color:s.c,background:s.bg,padding:'2px 8px',borderRadius:4,flexShrink:0}}>{s.l}</span>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontWeight:600,fontSize:13,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{n.title}</div>
                {n.content&&<div style={{fontSize:11,color:'#64748b',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{n.content}</div>}
              </div>
              <span style={{fontSize:10,color:'#94a3b8',flexShrink:0}}>{(n.createdAt||'').slice(0,10)}</span>
              <button onClick={function(){setEditNotice(n);setNoticeForm({title:n.title,content:n.content||'',priority:n.priority||'info'})}} style={{background:'none',border:'1px solid #d0d5dd',borderRadius:4,padding:'2px 6px',fontSize:10,cursor:'pointer'}}>✏️</button>
              <button onClick={function(){authFetch(API+'/admin/notices/'+n.id,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify({title:n.title,content:n.content,priority:n.priority,active:n.active?0:1})}).then(function(){fetchNotices()})}} style={{background:'none',border:'1px solid #d0d5dd',borderRadius:4,padding:'2px 6px',fontSize:10,cursor:'pointer'}}>{n.active?'🔕':'🔔'}</button>
              <button onClick={function(){setModal({type:'danger',title:'이 공지를 삭제할까요?',message:'',confirmText:'삭제',onConfirm:function(){closeModal();authFetch(API+'/admin/notices/'+n.id,{method:'DELETE'}).then(function(){fetchNotices()})}})}} style={{background:'none',border:'1px solid #fca5a5',borderRadius:4,padding:'2px 6px',fontSize:10,cursor:'pointer',color:'#dc2626'}}>🗑️</button>
            </div>);
          })}
        </div>
      </div>
    </div>}
    {modal && <CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
  </div>);
}

export default AdminCompany;
